import http, { url } from '../../http'

const API_URL = "procedures_protocols"

class procedimientosAPI {

  async save(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async saveEvidencia(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/evidence/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async updateEvidencia(evidenceUpdate,id) {
    const response = await http(`${API_URL}/evidence/update/${id}`, 'PUT', evidenceUpdate)
    return response
  }

  async saveMulti(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/multyStore/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async saveEvaluacion(calification_evaluation_providers) {
    const response = await http(`calification_evaluation_providers/save`, 'POST', calification_evaluation_providers)
    return response
  }
 
  async getAll(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

  async getAllE(id, evidencia) {
    const response = await http(`${API_URL}/evidence/index/${id}/${evidencia}`, 'POST')
    return response
  } 

  
  async getAllEvidence(id, evidencia, page, search) {
    const response = await http(`${API_URL}/evidence/index/${id}/${evidencia}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getListR() {
    const response = await http(`${API_URL}/riskList`)
    return response
  } 

  async getListS() {
    const response = await http(`${API_URL}/securityList`)
    return response
  } 

  async getAllS(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getContratistas(id) {
    const response = await http(`gsystem_occupational_hazards/list/${id}`)
    return response
  } 

  
  async getEmpleados(id) {
    const response = await http(`gsystem_occupational_hazards/listEmployees/${id}`)
    return response
  } 

  async getAllSeleccion(idEvaluacion) {
    const response = await http(`calification_evaluation_providers/${idEvaluacion}`)
    return response
  } 

  async getAllEvaluacionSeleccion(idEvaluacion, page, search) {
    const response = await http(`calification_evaluation_providers/${idEvaluacion}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getAllEvaluacion(page, search) {
    const response = await http(`${API_URL}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getShow(id) {
    const response = await http(`${API_URL}/evidence/show/${id}`)
    return response
  } 

  async getShowP(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  } 

  async getFiles(id) {
    const response = await http(`identification_evaluation_files/${id}`, 'POST')
    return response
  } 



  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }
  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async deleteP(id) {
    const response = await http(`${API_URL}/evidence/delete/${id}`, 'DELETE')
    return response
  }

  
}

export default new procedimientosAPI()